/*
 *
 *  sagas
 *
 */

import { call, take, put, race,  all } from "redux-saga/effects"

import {
  LOAD_RECORDS_META_DATA,
  LOAD_MANAGE_CLIENT,
  ADD_CRM,
  ADD_PRODUCT_ASSIGN,
  ADD_TEAM_ASSIGN,
  LOAD_PRODUCTION_ASSIGN_HISTORY,
  ADD_CLEARANCE,
  ADD_UNASSIGN,
  UPDATE_PROCESS,
  UPDATE_DATA,
  ASSIGN_PRINTPL,
  LOAD_MAIN_EVENT,
  UPDATE_MAIN_EVENT,
  UPDATE_DORMANT,
  UPDATE_ESCALATION
} from "./constants"

import {
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,
  loadCrmManageClient,
  loadCrmManageClientSuccess,
  addCrmAssignError,
  addCrmAssignSuccess,
  addClearanceError,
  addClearanceSuccess,
  addClearance,
  loadCrmManageClientError,
  addProductAssignSuccess,
  addProductAssignError,
  addTeamAssignSuccess,
  addTeamAssignError,
  loadProductionAssignHistory,
  loadProductionAssignHistorySuccess,
  loadProductionAssignHistoryError,
  crmReset,
  addUnassignSuccess,
  addUnassignError,
  updateDataSuccess,
  updateDataError,
  updateProcessSuccess,
  updateProcessError,
  assignPrintPlSuccess,
  assignPrintPlError,
  loadMainEvent,
  loadMainEventSuccess,
  loadMainEventError,
  updateMainEventSuccess,
  updateMainEventError,
  updateDormantSuccess,
  updateDormantError,
  updateEscalationSuccess,
  updateEscalationError
} from "./actions"

import {
  loadCrmManageClientApi,
  loadRecordsMetaData,
  addCrmAssignApi,
  addTeamAPI,
  addProductAPI,
  loadProductionAssignHistoryApi,
  addClearanceLevelDetails,
  addUnassignApi,
  updateDataApi,
  updateProcessAPI,
  assignPrintPlAPI,
  loadMainEventAPI,
  updateMainEventAPI,
  updateDormantAPI,
  updateEscalationAPI,
} from "./remotes"


function* loadCrmManageClientSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_MANAGE_CLIENT),
    })

    const { explicitLoad } = load

    const { searchvalue } = explicitLoad || {}
    yield put(loadCrmManageClient(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadCrmManageClientApi, searchvalue)
        console.log("api result is", result)

        if (result) {
          yield put(loadCrmManageClientSuccess(result.data))
          console.log(result.data)
        } else {
          yield put(loadCrmManageClientSuccess([]))
          yield put(loadCrmManageClientError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(loadCrmManageClientSuccess([]))
        yield put(
          loadCrmManageClientError(
            (error && error.response && error.response.message) ||
            "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* updateProcessSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { add } = yield race({
      add: take(UPDATE_PROCESS),
    })
    const { submitStatus } = add || {}
    if (add) {
      try {
        yield call(updateProcessAPI, submitStatus)
        yield put(
          updateProcessSuccess(
            submitStatus,
            "Record Updated Successfully"
          )
        )
      } catch (error) {
        yield put(
          updateProcessError(
            (error && error.response && error.response.message) ||
            "Updated Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}
function* loadRecordsMetaDataSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    yield race({
      metaData: take(LOAD_RECORDS_META_DATA),
    })

    try {
     
     

      const payload = {mode:"OPERATION"}
      const processStatus = yield call(loadRecordsMetaData, "all_process_status", "post")
      const deliver = yield call(loadRecordsMetaData, "all_process_status", "post",payload)
      const event = yield call(loadRecordsMetaData, "all_event", "post")
      const employee = yield call(loadRecordsMetaData,
        "all_employee_dropdown_list",
        "post")
      const product =  yield call(loadRecordsMetaData, "all_deliverable_product_category", "post")
   
      let recordsMetaData = {
       

        processStatusOptions:
          (processStatus &&
            processStatus.data &&
            processStatus.data.length > 0 &&
            processStatus.data
              .filter((_) => _.status === 1)
              .map((p) =>
                Object.assign(
                  {},
                  {
                    label: p.processStatus,
                    value: p._id,
                    processStatusId: p.processStatusId,
                    colorCode: p.colorCode,
                  }
                )
              )) ||
          [],
          deliverOptions:
          (deliver &&
            deliver.data &&
            deliver.data.length > 0 &&
            deliver.data
              .filter((_) => _.status === 1)
              .map((p) =>
                Object.assign(
                  {},
                  {
                    label: p.processStatus,
                    value: p.processStatusId,
                    processStatusId: p.processStatusId,
                    colorCode: p.colorCode,
                  }
                )
              )) ||
          [],
        eventOptions:
          (event &&
            event.data &&
            event.data.length > 0 &&
            event.data
              .filter((_) => _.status === 1)
              .map((c) =>
                Object.assign(
                  {},
                  {
                    label: c.eventName,
                    value: c._id,
                    eventCode: c.eventCode,
                    //  companyId: c.companyId
                  }
                )
              )) ||
          [],
        employeeOptions:
          (employee &&
            employee.data &&
            employee.data.length > 0 &&
            employee.data

              .map((c) =>
                Object.assign(
                  {},
                  {
                    label: c.empCode.concat(" - ", c.name),
                    value: c._id,

                  }
                )
              )) ||
          [],
          productOptions:
          (product &&
            product.data &&
            product.data.length > 0 &&
            product.data
              .filter((_) => _.status === 1)
              .map((p) =>
                Object.assign(
                  {},
                  {
                    label: p.productCategory,
                    value: p._id,
                   
                  }
                )
              )) ||
          [],

      }
      console.log(recordsMetaData, "my details")
      yield put(loadRecordsMetaDataSuccess(recordsMetaData))
    } catch (error) {
      yield put(
        loadRecordsMetaDataError(
          (error && error.response && error.response.message) ||
          "Fetch Dropdown Records Failed"
        )
      )
    }
  }
}


function*  addCrmDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { add } = yield race({
      add: take(ADD_CRM),
    })
    const { crm_details  } = add || {}
    if (add) {
      try {
       yield call(addCrmAssignApi, crm_details)
       yield put(addCrmAssignSuccess("CRM Assigned Successfully"))
       yield put(crmReset())
      } catch (error) {
        yield put(
          addCrmAssignError(
            (error && error.response && error.response.message) ||
            "CRM Assigned Failed"
          )
        )
        yield put(crmReset())
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

function* addTeamSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(ADD_TEAM_ASSIGN),
    })
    const { team_details } = create || {}
    if (create) {

      try {
        yield call(
          addTeamAPI,
          team_details
        )
        yield put(addTeamAssignSuccess(team_details))

      } catch (error) {
        yield put(
          addTeamAssignError(
            (error && error.response && error.response.message) ||
            "Create Record Failed"
          )
        )
      }
    }
  }
}

function* addProductSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { add } = yield race({
      add: take(ADD_PRODUCT_ASSIGN),
    })
    const { product_details } = add || {}
    if (add) {
      try {
        yield call(addProductAPI, product_details)
        yield put(
          addProductAssignSuccess(
            product_details,
            "Record Updated Successfully"
          )
        )
      } catch (error) {
        yield put(
          addProductAssignError(
            (error && error.response && error.response.message) ||
            "Updated Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

function* loadProductionAssignHistorySaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_PRODUCTION_ASSIGN_HISTORY),
    })

    const { explicitLoad } = load

    const { historyPayload } = explicitLoad || {}
    yield put(loadProductionAssignHistory(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadProductionAssignHistoryApi, historyPayload)
        console.log("api result is", result)

        if (result) {
          yield put(loadProductionAssignHistorySuccess(result.data))
          console.log(result.data)
        } else {
          yield put(loadProductionAssignHistorySuccess([]))
          yield put(loadProductionAssignHistoryError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(loadProductionAssignHistorySuccess([]))
        yield put(
          loadProductionAssignHistoryError(
            (error && error.response && error.response.message) ||
            "Fetch Records Failed"
          )
        )
      }
    }
  }
}
function* addClearanceDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(ADD_CLEARANCE),
    })

    const { explicitLoad } = load

    const { applyClearance } = explicitLoad || {}
    yield put(addClearance(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(addClearanceLevelDetails, applyClearance)
        console.log("api result is", result)

        if (result) {
          yield put(addClearanceSuccess("Clearance Updated Successfully"))
          yield put(crmReset())
          console.log(result.data)
        } else {
         
          yield put(addClearanceError("Clearance Updated Failed"))
        }
      } catch (error) {
        yield put(
          addClearanceError(
            (error && error.response && error.response.message) ||
            "Clearance Updated Failed"
          )
        )
        yield put(crmReset())
      }
    }
  }
}

function*  addUnassignSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { add } = yield race({
      add: take(ADD_UNASSIGN),
    })
    const { unAssign_data  } = add || {}
    if (add) {
      try {
       yield call(addUnassignApi, unAssign_data)
       yield put(addUnassignSuccess("UnAssigned Successfully"))
       yield put(crmReset())
      } catch (error) {
        yield put(
          addUnassignError(
            (error && error.response && error.response.message) ||
            "UnAssigned Failed"
          )
        )
        yield put(crmReset())
      } finally {
        //error
      }
    }
  }
}

function* updateDataSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(UPDATE_DATA),
    })
    const {dataDetails } = create || {}
    if (create) {
     
      try {
        yield call(
          updateDataApi,
          dataDetails
        )
          yield put(updateDataSuccess(dataDetails))
        
      } catch (error) {
        yield put(
          updateDataError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      }
    }
  }
}

function* assignPrintPlSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(ASSIGN_PRINTPL),
    })
    const { print_details } = create || {}
    if (create) {
     
      try {
        yield call(
          assignPrintPlAPI,
          print_details
        )
          yield put(assignPrintPlSuccess(print_details))
        
      } catch (error) {
        yield put(
          assignPrintPlError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      }
    }
  }
}
function* loadMainEventSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_MAIN_EVENT),
    })

    const { explicitLoad } = load

    const { eventDetails } = explicitLoad || {}
    yield put(loadMainEvent(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadMainEventAPI,eventDetails)
        console.log("api result is", result)

        if (result) {
          yield put(loadMainEventSuccess(result.data))
          console.log(result.data)
        } else {
          yield put(loadMainEventSuccess([]))
          yield put(loadMainEventError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(loadMainEventSuccess([]))
        yield put(
          loadMainEventError(
            (error && error.response && error.response.message) ||
            "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* updateMainEventSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(UPDATE_MAIN_EVENT),
    })
    const {update_event } = create || {}
    if (create) {
     
      try {
        yield call(
          updateMainEventAPI,
          update_event
        )
          yield put(updateMainEventSuccess(update_event))
        
      } catch (error) {
        yield put(
          updateMainEventError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      }
    }
  }
}
//updateDormant

function* updateDormantSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(UPDATE_DORMANT),
    })
    const {dormant_details } = create || {}
    if (create) {
     
      try {
        yield call(
          updateDormantAPI,
          dormant_details
        )
          yield put(updateDormantSuccess(dormant_details))
        
      } catch (error) {
        yield put(
          updateDormantError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      }
    }
  }
}
//updateEscalation

function* updateEscalationSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(UPDATE_ESCALATION),
    })
    const {escalation_details } = create || {}
    if (create) {
     
      try {
        yield call(
          updateEscalationAPI,
          escalation_details
        )
          yield put(updateEscalationSuccess(escalation_details))
        
      } catch (error) {
        yield put(
          updateEscalationError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      }
    }
  }
}

export default function* recordsSaga() {
  yield all([
    loadRecordsMetaDataSaga(),
    loadCrmManageClientSaga(),
    addCrmDetailsSaga(),
    addTeamSaga(),
    addProductSaga(),
    loadProductionAssignHistorySaga(),
    addClearanceDetailsSaga(),
    addUnassignSaga(),
    updateDataSaga(),
    updateProcessSaga(),
    assignPrintPlSaga(),
    loadMainEventSaga(),
    updateMainEventSaga(),
    updateDormantSaga(),
    updateEscalationSaga()
  ])
}
